import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./store";
import "./i18n.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore({})}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </Provider>
);
